module.exports = __webpack_public_path__ + "img/UC-Introduction_to_unit_testing.f71d1ac6.jpg";